import React from 'react';
import { CellField, DataTableColumn } from '@/components/custom/erp';
import { ChiTietKheUocThanhToan } from '@/types/schemas';

export const getInvoiceCollectionColumns = (
  onCellValueChange: (
    rowUuid: string,
    field: keyof ChiTietKheUocThanhToan,
    newValue: ChiTietKheUocThanhToan[keyof ChiTietKheUocThanhToan]
  ) => void
): DataTableColumn<ChiTietKheUocThanhToan>[] => [
  {
    field: 'ngay_tt',
    headerName: 'Ngày thanh toán',
    width: 150,
    renderCell: params => (
      <CellField
        name='ngay_tt'
        type='date'
        value={params.row.ngay_tt}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'ngay_tt', newValue)}
      />
    )
  },
  {
    field: 'tt',
    headerName: 'Tiền thanh toán',
    width: 150,
    renderCell: params => (
      <CellField
        name='tt'
        type='number'
        placeholder='0'
        value={params.row.tt}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'tt', newValue)}
      />
    )
  },
  {
    field: 'tt_nt',
    headerName: 'Tiền thanh toán nt',
    width: 150,
    renderCell: params => (
      <CellField
        name='tt_nt'
        type='number'
        placeholder='0'
        value={params.row.tt_nt}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'tt_nt', newValue)}
      />
    )
  },
  {
    field: 'ghi_chu',
    headerName: 'Ghi chú',
    width: 200,
    renderCell: params => (
      <CellField
        name='ghi_chu'
        type='text'
        value={params.row.ghi_chu || ''}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'ghi_chu', newValue)}
      />
    )
  }
];
